export const lowercaseCharacterRegex = /(?=.*[a-z])/

export const uppercaseCharacterRegex = /(?=.*[A-Z])/

export const numberCharacterRegex = /(?=.*[0-9])/
